import React from 'react';
import { Text } from 'components/Typography';
import { ComingSoonLabel } from 'containers/ComingSoonLabel/ComingSoonLabel';
import { SVGBasicType } from 'types/global';
import { Color } from 'utils/color';
import style from './BasicCard.scss';

type Props = {
  title?: string;
  imgSrc?: string;
  icon: React.FC<SVGBasicType>;
  size?: 'sm' | 'lg';
  hasComingSoonLabel?: boolean;
  value?: string | number;
  unit?: string;
};

export const BasicCard: React.FC<Props> = ({ title, icon: Icon, size = 'lg', hasComingSoonLabel = false, value = '-', unit }) => {
  const isLarge = size === 'lg';

  if (!isLarge) {
    return (
      <div className={style.smallCard}>
        <div className={style.content}>
          <Icon width={32} height={32} color={Color.GRAY} />
          <div className={style.textWrapper}>
            <Text variant="nlg" className={style.title}>
              {title}
            </Text>
            {hasComingSoonLabel ? (
              <ComingSoonLabel />
            ) : (
              <Text variant="h5" weight={500}>
                {value || '-'}
              </Text>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={style.card}>
      <div className={style.cardTitleContainer}>
        <Text variant="md" weight={500}>
          {title}
        </Text>
      </div>
      <div className={style.content}>
        <Icon />
        <div className={style.vitalValueContainer}>
          <Text variant="h3" className={style.vitalValueText}>
            {value ?? '-'}
          </Text>
          {unit && (
            <Text variant="md" className={style.vitalValueUnit}>
              {unit}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
